import { render, staticRenderFns } from "./WhsL.vue?vue&type=template&id=37bf08df"
import script from "./WhsL.vue?vue&type=script&lang=js"
export * from "./WhsL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports